import type { DisruptionPnrGroupRow } from './types';

/** The passenger's own "prefiero ir a mi domicilio" decision (#811), when cases stamped one. */
export interface IGoingHome {
  address?: string;
  wantsTransportHome: boolean;
  returnPickupAt?: string;
  decidedAt?: string;
}

/**
 * Only a PASSENGER-sourced SELF_MANAGED outcome is "going home": the hotel desk's
 * own SELF_MANAGED (voucher, passenger arranges a stay) and the operator's
 * stay-home declaration keep their existing presentation.
 */
export function goingHomeOf(group: Pick<DisruptionPnrGroupRow, 'accommodationOutcome'>): IGoingHome | null {
  const o = group.accommodationOutcome;
  if (!o || o.outcome !== 'SELF_MANAGED' || o.source !== 'PASSENGER') return null;
  return {
    ...(o.address ? { address: o.address } : {}),
    wantsTransportHome: o.wantsTransportHome === true,
    ...(o.returnPickupAt ? { returnPickupAt: o.returnPickupAt } : {}),
    ...(o.decidedAt ? { decidedAt: o.decidedAt } : {}),
  };
}
